import React, { Component } from 'react';
import { Col, Row, Card, CardBody, } from 'reactstrap';
import PropTypes from 'prop-types';
import { TextInput, SlFormEntryRow, SlYesNo, ReadOnlyField } from '../editors'
import { metadataService } from '../../_services'
import validator from 'validator';
import { LanguagePreferences } from "./LanguagePreferences";
import moment from "moment";

export class AccountInfo extends Component {
    constructor(props) {
        super(props);

        let propsValue = this.props.value;

        this.state = {
            formValue: this.getFormValueFromProps(propsValue),
            fieldErrors: [],
        };

        this.handleInput = this.handleInput.bind(this);
        this.handleChangeState = this.handleChangeState.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
    }

    componentDidMount() {
        if (this.props.isValid) {
            var validation = this.getValidationErrors(this.state);
            this.props.isValid(this.props.name, validation.isValid);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            var validation = this.getValidationErrors(this.state);
            this.props.isValid(this.props.name, validation.isValid);
            this.setState({ formValue: this.getFormValueFromProps(this.props.value) });
        }
    }

    getFormValueFromProps(propsValue) {
        
        let formValue = {
            firstName: propsValue.firstName ? propsValue.firstName : '',
            lastName: propsValue.lastName ? propsValue.lastName : '',
            email: propsValue.email ? propsValue.email : '',
            confirmEmail: propsValue.confirmEmail ? propsValue.confirmEmail : '',
            mobilePhone: propsValue.mobilePhone ? propsValue.mobilePhone : '',
            alternateMobilePhone: propsValue.alternateMobilePhone ? propsValue.alternateMobilePhone : '',
            dateOfBirth: propsValue.dateOfBirth ? propsValue.dateOfBirth : '',
            sendMobileNotifications: propsValue.sendMobileNotifications !== undefined ? propsValue.sendMobileNotifications : true
        };

        return formValue;
    }

    handleOnBlur = ({ target: { name, value } }) => {
        this.setState({ visited: true });
    }

    handleInput = ({ target: { name, value } }) => {

        const formValue = { ...this.state.formValue, [metadataService.jsonFieldName(name)]: value };
        let newState = {
            ...this.state,
            formValue: formValue
        };

        if (name === "SendMobileNotifications") {
            newState.formValue.sendMobileNotifications = value === "true";
        }

        this.handleChangeState(newState);

        var validation = this.getValidationErrors(newState);
        this.props.isValid(name, validation.isValid);

        let returnValue = {
            isValid: validation.isValid,
            firstName: newState.formValue.firstName,
            lastName: newState.formValue.lastName,
            dateOfBirth: newState.formValue.dateOfBirth,
            email: newState.formValue.email,
            confirmEmail: newState.formValue.confirmEmail,
            mobilePhone: newState.formValue.mobilePhone,
            alternateMobilePhone: newState.formValue.alternateMobilePhone,
            sendMobileNotifications: newState.formValue.sendMobileNotifications
        };

        this.props.onChange({ target: { name: this.props.name, value: returnValue } });
    };

    handleChangeState(newState){
        this.setState(newState)
    }

    getValidationErrors(checkState) {
        let validation = {
            isValid: true,
            validationError: []
        };
        const {nonRequiredFields} = this.props;
        if (!this.props.hiddenFields.includes("FirstName") && validator.isEmpty(checkState.formValue.firstName)) {
            validation.isValid = false;
            validation.validationError.push({ fieldName: "FirstName", messageName: "RequiredFieldNotSupplied" });
        }

        if (!this.props.hiddenFields.includes("LastName") && validator.isEmpty(checkState.formValue.lastName)) {
            validation.isValid = false;
            validation.validationError.push({ fieldName: "LastName", messageName: "RequiredFieldNotSupplied" });
        }

        if (!this.props.hiddenFields.includes("Email")) {

            if (validator.isEmpty(checkState.formValue.email)) {
                validation.isValid = false;
                validation.validationError.push({ fieldName: "Email", messageName: "RequiredFieldNotSupplied" });
            }
            else {
                if (!validator.isEmail(checkState.formValue.email)) {
                    validation.isValid = false;
                    validation.validationError.push({ fieldName: "Email", messageName: "InvalidFormat" });
                }
            }

            if (!this.props.hiddenFields.includes("ConfirmEmail")) {
                if (validator.isEmpty(checkState.formValue.confirmEmail)) {
                    validation.isValid = false;
                    validation.validationError.push({ fieldName: "ConfirmEmail", messageName: "RequiredFieldNotSupplied" });
                }
                else {
                    if (!validator.equals(checkState.formValue.email, checkState.formValue.confirmEmail)) {
                        validation.isValid = false;
                        validation.validationError.push({ fieldName: "ConfirmEmail", messageName: "InvalidFormat" });
                    }
                }
            }
        }

        if (!this.props.hiddenFields.includes("MobilePhone")) {

            if (!nonRequiredFields.includes("MobilePhone") && validator.isEmpty(checkState.formValue.mobilePhone)) {
                validation.isValid = false;
                validation.validationError.push({ fieldName: "MobilePhone", messageName: "RequiredFieldNotSupplied" });
            }
            else {
                if (!validator.isEmpty(checkState.formValue.mobilePhone + "") && !validator.isMobilePhone(checkState.formValue.mobilePhone + '', 'en-US')) {
                    validation.isValid = false;
                    validation.validationError.push({ fieldName: "MobilePhone", messageName: "MobilePhoneError" });
                }
            }
        }
        if (!this.props.hiddenFields.includes("AlternateMobilePhone")) {

            if (checkState.formValue.alternateMobilePhone && !validator.isEmpty(checkState.formValue.alternateMobilePhone)) {
                if (!validator.isMobilePhone(checkState.formValue.alternateMobilePhone + '', 'en-US')) {
                    validation.isValid = false;
                    validation.validationError.push({ fieldName: "AlternateMobilePhone", messageName: "MobilePhoneError" });
                }                
            } 
        }

        if (!this.props.hiddenFields.includes("DateOfBirth")) {
            if (validator.isEmpty(checkState.formValue.dateOfBirth)) {
                validation.isValid = false;
                validation.validationError.push({ fieldName: "DateOfBirth", messageName: "RequiredFieldNotSupplied" });
            }
            else {
                if (checkState.formValue.dateOfBirth) {
                    var yearsOld = moment().diff(checkState.formValue.dateOfBirth, 'years');
                    let dobError = yearsOld < 18;
                    if (dobError) {
                        validation.isValid = false;
                        validation.validationError.push({ fieldName: "DateOfBirth", messageName: "BorrowerMustBe18" });
                    }
                }
            }
        }
        return validation;
    }

    render() {
        const {nonRequiredFields, readOnlyFields} = this.props;        
        return (
            <div>
                 {readOnlyFields.includes("MobilePhone") && <Card>                 
                    {(this.state.formValue.mobilePhone != null && this.state.formValue.mobilePhone != "") && (
                        <CardBody>
                            <ReadOnlyField name="MobilePhone" value={this.state.formValue.mobilePhone + ""}></ReadOnlyField>
                        </CardBody>
                        )
                    }
                </Card>}
                {!this.props.hiddenFields.includes("FirstName") && (
                    <SlFormEntryRow>
                        <TextInput
                            name="FirstName"
                            value={this.state.formValue.firstName}
                            disabled={this.props.readOnly}
                            onChange={this.handleInput} maxLength='30' />
                    </SlFormEntryRow>)}
                {!this.props.hiddenFields.includes("LastName") && (
                    <SlFormEntryRow>
                        <TextInput
                            name="LastName"
                            value={this.state.formValue.lastName}
                            disabled={this.props.readOnly}
                            onChange={this.handleInput}
                            maxLength='30' />
                    </SlFormEntryRow>)}
                {!this.props.hiddenFields.includes("DateOfBirth") && (
                    <SlFormEntryRow>
                        <Row>
                            <Col className={"text-center"}>
                                <TextInput
                                    name='DateOfBirth'
                                    label={metadataService.getFieldNameLabel("DOB")}
                                    fieldErrors={this.state.fieldErrors}
                                    value={this.state.formValue.dateOfBirth}
                                    disabled={this.props.readOnly}
                                    onChange={this.handleInput}
                                    maskOnBlur={true}
                                    type='date' />
                            </Col>
                        </Row>
                    </SlFormEntryRow>)}
                {!this.props.hiddenFields.includes("Email") && (
                    <SlFormEntryRow>
                        <TextInput
                            name="Email"
                            value={this.state.formValue.email}
                            disabled={this.props.readOnly}
                            onChange={this.handleInput} />
                    </SlFormEntryRow>)}
                {!this.props.hiddenFields.includes("ConfirmEmail") && (
                    <SlFormEntryRow>
                        <TextInput
                            name="ConfirmEmail"
                            value={this.state.formValue.confirmEmail}
                            disabled={this.props.readOnly}
                            onChange={this.handleInput} />
                    </SlFormEntryRow>)}
                {!this.props.hiddenFields.includes("MobilePhone") && (
                    <SlFormEntryRow>
                        <TextInput
                            name="MobilePhone"
                            value={this.state.formValue.mobilePhone}
                            disabled={this.props.readOnly}
                            onChange={this.handleInput}
                            fieldErrors={this.state.fieldErrors}
                            maxLength='10'
                            isRequired={!nonRequiredFields.includes("MobilePhone")} />
                    </SlFormEntryRow>)}
            
                {!this.props.hiddenFields.includes("SendMobileNotifications") && (
                    <div>
                        <SlFormEntryRow>
                            <div className="text-center">
                                <h4>{"Would you like us to send account notifications to this number?"}</h4>
                            </div>
                        </SlFormEntryRow>
                        <SlFormEntryRow>
                            <SlYesNo name="SendMobileNotifications"
                                value={this.state.formValue.sendMobileNotifications}
                                trueValue={true}
                                falseValue={false}
                                trueText={metadataService.getLabel("Yes")}
                                falseText={metadataService.getLabel("No")}
                                disabled={this.props.readOnly}
                                onChange={this.handleInput} />
                        </SlFormEntryRow>
                    </div>)}
                {!this.props.hiddenFields.includes("AlternateMobilePhone") && (
                    <SlFormEntryRow>
                        <TextInput
                            name="AlternateMobilePhone"
                            value={this.state.formValue.alternateMobilePhone}
                            disabled={this.props.readOnly}
                            onChange={this.handleInput}
                            fieldErrors={this.state.fieldErrors}
                            maxLength='10' />
                    </SlFormEntryRow>)}
                {!this.props.hiddenFields.includes("LanguagePreference") && (
                    <LanguagePreferences onChange={this.handleInput} />)}
            </div>
        );
    }
}

//Define prop types
AccountInfo.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    showLabel: PropTypes.bool,
    value: PropTypes.object,
    fieldErrors: PropTypes.array,
    isValid: PropTypes.func,
    hiddenFields: PropTypes.array,
    readonly: PropTypes.bool,
    nonRequiredFields: PropTypes.array,
    readOnlyFields: PropTypes.array,
}
AccountInfo.defaultProps = {
    showLabel: true,
    value: {},
    hideFields: [],
    readOnly: false,
    nonRequiredFields : [],
    readOnlyFields : [],
}


// WEBPACK FOOTER //
// ./src/components/subcomponents/AccountInfo.js